<div
  #modalbackground
  class="background-documents"
  (click)="close($event)"
></div>
<ops-file-attach-spinner *ngIf="uploading" type="upload" />
<ops-file-attach-spinner *ngIf="removing" type="remove" />
<div class="documents-modal-window">
  <div class="title">{{ title | translate }} - {{ 'documentModal.documents' | translate }}</div>
  <div class="content">
    <div class="bills-clmn column">
      <div class="header">
        <input 
          hidden
          type="file"
          multiple
          accept=".pdf, .jpg, .jpeg, .heic, .png, .xlsx, .xls, .csv, .doc, .docx, .txt, .ods, .pages, .numbers"
          #uploaderInvoice
          (change)="uploadFiles($event, 'invoice')"
        />
        <div class="add-btn" *ngIf="!readonly && invoiceFiles.length < 3">
          <img
            src="assets/plus-in-circle-purple.svg"
            (click)="uploaderInvoice.click()"
          />
        </div>
        <div class="label">{{ 'documentModal.bills' | translate }} {{ invoiceFiles.length }}/3</div>
      </div>
      <div class="file" *ngFor="let invoiceFile of invoiceFilesMap">
        <img src="assets/document-icon-blue.svg" />
        <div class="label" (click)="previewFile(invoiceFile)">
          <span class="file-name" title="{{ invoiceFile.name }}">{{ invoiceFile.fileName }}</span>&nbsp;|&nbsp;
          <span class="file-extension">{{ invoiceFile.extensionName }}</span>
        </div>
        <div class="delete-icon" *ngIf="!readonly && !preventDelete" (click)="removeFile(invoiceFile)">
          <img src="assets/cross-in-circle-red-small.svg" />
        </div>
      </div>
    </div>
    <div class="payment-clmn column">
      <div class="header">
        <input 
          hidden
          type="file"
          multiple
          accept=".pdf, .jpg, .jpeg, .heic, .png, .xlsx, .xls, .csv, .doc, .docx, .txt, .ods, .pages, .numbers"
          #uploaderPayment
          (change)="uploadFiles($event, 'payment')"
        />
        <div class="add-btn" *ngIf="!readonly && paymentFiles.length < 3">
          <img
            src="assets/plus-in-circle-purple.svg"
            (click)="uploaderPayment.click()"
          />
        </div>
        <div class="label">{{ 'documentModal.paymentStatement' | translate }} {{ paymentFiles.length }}/3</div>
      </div>
      <div class="file" *ngFor="let paymentFile of paymentFilesMap">
        <img src="assets/document-icon-blue.svg" />
        <div class="label" [class.readonly]="readonly" (click)="previewFile(paymentFile)">
          <span class="file-name" title="{{ paymentFile.name }}">{{ paymentFile.fileName }}</span>&nbsp;|&nbsp;
          <span class="file-extension">{{ paymentFile.extensionName }}</span>
        </div>
        <div class="delete-icon" *ngIf="!readonly && !preventDelete">
          <img
            src="assets/cross-in-circle-red-small.svg"
            (click)="removeFile(paymentFile)"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="close-btn" (click)="close($event)">{{ 'documentModal.ok' | translate }}</div>
  </div>
</div>
